import React, { useState, useEffect, useLayoutEffect } from "react";
import "./CreateJumboForm.scss";
import "./CreateFormBuilder.scss";
import { useUser } from "contexts/userContext/userContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useParams } from "react-router-dom";
import config from "config";
import Cookies from "universal-cookie";
import { useModal } from "contexts/modalContext/modalContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Button from "components/Elements/Button/Button.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import {
  defaultFormImages,
  embedColorCode,
} from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";
import useJumboFormSettings from "./Helpers/useJumboFormSettings.js";
import LoadingContainerElement from "components/Elements/LoadingContainerElement/LoadingContainerElement.js";
import ProductTourWrapper from "components/Reusable/ProductTour/ProductTourWrapper";
import NotLoginContainer from "components/Reusable/NotLoginContainer/NotLoginContainer";
import Login from "components/Structure/Login/Login";
import PreviewForm from "../ProfileUser/JumboEmbed/FormManagement/PreviewForm";
import { ImportUserForm } from "./Helpers/externalFunctions";
import CreateFormContainer from "./CreateJumboFormContent/CreateFormContainer";
import getAsyncImage from "utils/getAsyncImage";

const CreateJumboForm = () => {
  const { setModal } = useModal();
  const params = useParams();
  const { getTextByKey, getPath, getLanguageCulture, getDirection } =
    useContent();
  const { getUserData, isLoggedIn, isPremium, isSubscribed, isBusiness } =
    useUser();
  const numOfForms = getUserData().JumboFormsCount;
  const [embedUser, setEmbedUser] = useState(
    !isPremium() ? (numOfForms > 0 ? false : true) : true
  );
  const [loadingLoggin, setLoadingLoggin] = useState(true);
  const [formId, setFormId] = useState(null);
  const [oldFormId, setOldFormId] = useState(null);
  const userData = getUserData();
  const [editOrCreate, setEditOrCreate] = useState("create");
  const [formUserValidation, setFormUserValidation] = useState(true);
  const [loading, setLoading] = useState(true);
  //step 1 - Design Tools:
  const [formButtonsColor, setFormButtonsColor] = useState(embedColorCode);
  const [formButtonTextColor, setFormButtonTextColor] = useState("#ffffff");
  const [formBackgroundColor, setFormBackgroundColor] = useState("#ffffff");
  const [formWidth, setFormWidth] = useState(460);
  const [formMaxHeight, setFormMaxHeight] = useState(0);
  const [directionForm, setDirectionForm] = useState(getDirection());
  //step 1 - form Design:
  const [formLanguage, setFormLanguage] = useState(getLanguageCulture());
  const [formDisplayTitle, setFormDisplayTitle] = useState("");
  const [formDescription, setFormDescription] = useState("");
  const [formImage, setFormImage] = useState(null);
  const [formJson, setFormJson] = useState(null);
  const [formHeight, setFormHeight] = useState(516);
  //step 1 - form Footer Design:
  const [linkFooters, setLinkFooters] = useState([
    {
      FooterLinkTitle: getTextByKey("about-footer"),
      FooterLinkUrl: config.baseurl + getPath() + "jumbo-forms",
    },
    {
      FooterLinkTitle: getTextByKey("support-footer"),
      FooterLinkUrl: config.baseurl + getPath() + "support/jumbo-embed",
    },
    {
      FooterLinkTitle: getTextByKey("terms-footer"),
      FooterLinkUrl: config.baseurl + getPath() + "terms",
    },
  ]);
  const [editCustomFooterLinks, setEditCustomFooterLinks] = useState(false);
  const [displayFooterLinks, setDisplayFooterLinks] = useState(isPremium());

  //Step 2 - Settings :
  const [emailToReceiveFiles, setEmailToReceiveFiles] = useState(""); //EmbedDynamicRecipients
  const [uploadFilesLimit, setUploadFilesLimit] = useState(0);
  const limitSize = isPremium() ? 19 : isSubscribed() ? 7 : 2;
  const [fileSizeLimit, setFileSizeLimit] = useState(limitSize); //EmbedDynamicMaxSizeId
  const [manuallyDeleteCheckbox, setManuallyDeleteCheckbox] = useState(false); //EmbedDynamicManuallyDelete
  const [automaticallyDeleteCheckbox, setAutomaticallyDeleteCheckbox] =
    useState(true); //!EmbedDynamicManuallyDelete
  const [daysToDelete, setDaysToDelete] = useState(3); //EmbedDynamicDeleteDays
  const [uploadAnyFormatsCheckbox, setUploadAnyFormatsCheckbox] =
    useState(true); //EmbedDynamicFormatsAction
  const [allowFolowingFormatsCheckbox, setAllowFolowingFormatsCheckbox] =
    useState(false); //EmbedDynamicFormatsAction
  const [denyForamtsCheckbox, setDenyForamtsCheckbox] = useState(false); //EmbedDynamicFormatsAction
  const [fileFormats, setFileFormats] = useState(""); //EmbedDynamicFormats
  const [potentialCustomers, setPotentialCustomers] = useState(false); //EmbedDynamicSendLead
  const [customersFilesDownloaded, setCustomersFilesDownloaded] =
    useState(false); //EmbedDynamicSendDownload
  const [orderConfirmation, setOrderConfirmation] = useState(false); //EmbedDynamicSendCopy
  const [sendEmailToRecipients, setSendEmailToRecipients] = useState(true); //Embed_Dynamic_Send_Mail_Recipients
  const [displayLink, setDisplayLink] = useState(true); //EmbedDynamicEndDownloadLink
  const [displaySendAnotherEmail, setDisplaySendAnotherEmail] = useState(true); //EmbedDynamicEndSendButton
  const [thankyouPageRedirect, setThankyouPageRedirect] = useState(false); //EmbedDynamicRedirect
  const [deleteMailLink, setDeleteMailLink] = useState(false);
  const [redirectLink, setRedirectLink] = useState(""); //EmbedDynamicRedirectUrl
  const [protectFormWithPassword, setProtectFormWithPassword] = useState(false); //EmbedDynamicSetPassword
  const [passwordForm, setPasswordForm] = useState(""); //EmbedDynamicPassword
  const [allowAccess, setAllowAccess] = useState(false); //EmbedDynamicAllowAccess
  const [showDescription, setShowDescription] = useState(true);
  const [showTitle, setShowTitle] = useState(true);
  const [showImage, setShowImage] = useState(true);
  const [displayToSubUsers, setDisplayToSubUsers] = useState(true);
  const [displayTypeSubUsers, setDisplayTypeSubUsers] = useState("All");
  // Security Settings
  const [listDomains, setListDomains] = useState([]);
  const [isCheckedPreventDisplayForm, setIsCheckedPreventDisplayForm] =
    useState(false);
  //step 3 - Get Code:
  const [websiteURL, setWebsiteURL] = useState("");
  const [errorIdDisplay, setErrorIdDisplay] = useState(false);
  const [viewMode, setViewMode] = useState("gallery"); //ViewMode

  //if user not loggin - open login modal and if login - return back the page if not - go to home page
  const cookies = new Cookies();
  const isTokenExist = cookies.get(config.api.jumbomailApiAuthCookie);
  useLayoutEffect(() => {
    if (!isTokenExist) {
      setModal({
        modal: Login,
        modalSize: "full-modal",
      });
    }
  }, [isTokenExist]);

  useEffect(() => {
    //after 0.5 sec, change loadingLoggin to false
    setTimeout(() => {
      setLoadingLoggin(false);
    }, 500);
  }, []);

  //check if edit form and get the form if edit
  useEffect(() => {
    if (params) {
      if (
        params.EmbedDynamicId &&
        params.EmbedDynamicId !== undefined &&
        userData &&
        userData.UserId
      ) {
        getFormDetails();
      } else {
        let randNum = Math.floor(Math.random() * 18);
        getAsyncImage(
          `images/${defaultFormImages[randNum]}.webp`,
          setFormImage
        );
        setEmailToReceiveFiles(userData ? userData.UserName : "");
        setLoading(false);
      }
    }
  }, [params, userData]);

  //get form details
  const getFormDetails = async () => {
    setLoading(true);
    const parameters = {
      embedDynamicId: params.EmbedDynamicId,
      updateForm: true,
      //fixRequiredDropDown: false,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "GetFormFooterReact",
      parameters
    );

    if (response.status === "success") {
      if (response.data.EmbedForm) {
        setErrorIdDisplay(false);
        setEditOrCreate("edit");
        ImportUserForm({
          isBusiness: isBusiness,
          isPremium: isPremium,
          isSubscribed: isSubscribed,
          EmbedForm: response.data.EmbedForm,
          EmbedFooterLinksList: response.data.EmbedFooterLinksList,
          setListDomains,
          setIsCheckedPreventDisplayForm,
          setLinkFooters,
          setDisplayFooterLinks,
          setEditCustomFooterLinks,
          setFormId,
          setOldFormId,
          setFormWidth,
          setFormHeight,
          setFormLanguage,
          setFormDisplayTitle,
          setFormDescription,
          setFormImage,
          setFormJson,
          setEmailToReceiveFiles,
          setUploadFilesLimit,
          setFileSizeLimit,
          setManuallyDeleteCheckbox,
          setAutomaticallyDeleteCheckbox,
          setDaysToDelete,
          setPotentialCustomers,
          setCustomersFilesDownloaded,
          setOrderConfirmation,
          setDisplayLink,
          setDisplaySendAnotherEmail,
          setThankyouPageRedirect,
          setRedirectLink,
          setProtectFormWithPassword,
          setPasswordForm,
          setAllowFolowingFormatsCheckbox,
          setDenyForamtsCheckbox,
          setUploadAnyFormatsCheckbox,
          setFileFormats,
          setFormButtonsColor,
          setFormButtonTextColor,
          setFormBackgroundColor,
          setWebsiteURL,
          setShowDescription,
          setShowImage,
          setShowTitle,
          setDirectionForm,
          setAllowAccess,
          setDisplayToSubUsers,
          setSendEmailToRecipients,
          setFormMaxHeight,
          setDeleteMailLink,
          setDisplayTypeSubUsers,
        });

        setLoading(false);
      } else {
        setErrorIdDisplay(true);

        setLoading(false);
      }
    } else {
      if (response.data === "access-denied") {
        setFormUserValidation(false);
      }
      setErrorIdDisplay(true);
      setLoading(false);
    }
  };

  //Preview form by id
  const previewFormById = () => {
    setModal({
      modal: PreviewForm,
      modalSize: "full-modal",
      props: {
        width: formWidth,
        height: formHeight,
        formId: formId,
        isPreview: true,
        embedPageFormImage: formImage,
      },
    });
  };

  useJumboFormSettings({ setEmbedUser, setLoading });

  return (
    <>
      {!loading && !loadingLoggin ? (
        isLoggedIn() ? (
          <div className="create-form-container">
            {(editOrCreate === "create" && embedUser && !errorIdDisplay) ||
            (editOrCreate === "edit" &&
              formUserValidation &&
              !errorIdDisplay) ? (
              <>
                <CreateFormContainer
                  directionForm={directionForm}
                  setDirectionForm={setDirectionForm}
                  userData={userData}
                  formButtonsColor={formButtonsColor}
                  formButtonTextColor={formButtonTextColor}
                  setFormButtonTextColor={setFormButtonTextColor}
                  setFormButtonsColor={setFormButtonsColor}
                  formBackgroundColor={formBackgroundColor}
                  setFormBackgroundColor={setFormBackgroundColor}
                  editOrCreate={editOrCreate}
                  setFormLanguage={setFormLanguage}
                  formId={formId}
                  setFormId={setFormId}
                  setFormWidth={setFormWidth}
                  formWidth={formWidth}
                  setFormHeight={setFormHeight}
                  formHeight={formHeight}
                  formLanguage={formLanguage}
                  formJson={formJson}
                  setFormJson={setFormJson}
                  setFormDisplayTitle={setFormDisplayTitle}
                  formDisplayTitle={formDisplayTitle}
                  formDescription={formDescription}
                  setFormDescription={setFormDescription}
                  previewFormById={previewFormById}
                  formImage={formImage}
                  setFormImage={setFormImage}
                  websiteURL={websiteURL}
                  setWebsiteURL={setWebsiteURL}
                  displayFooterLinks={displayFooterLinks}
                  setDisplayFooterLinks={setDisplayFooterLinks}
                  editCustomFooterLinks={editCustomFooterLinks}
                  setEditCustomFooterLinks={setEditCustomFooterLinks}
                  linkFooters={linkFooters}
                  setLinkFooters={setLinkFooters}
                  emailToReceiveFiles={emailToReceiveFiles} //Settings
                  setEmailToReceiveFiles={setEmailToReceiveFiles}
                  uploadFilesLimit={uploadFilesLimit}
                  setUploadFilesLimit={setUploadFilesLimit}
                  fileSizeLimit={fileSizeLimit}
                  setFileSizeLimit={setFileSizeLimit}
                  manuallyDeleteCheckbox={manuallyDeleteCheckbox}
                  setManuallyDeleteCheckbox={setManuallyDeleteCheckbox}
                  automaticallyDeleteCheckbox={automaticallyDeleteCheckbox}
                  setAutomaticallyDeleteCheckbox={
                    setAutomaticallyDeleteCheckbox
                  }
                  daysToDelete={daysToDelete}
                  setDaysToDelete={setDaysToDelete}
                  uploadAnyFormatsCheckbox={uploadAnyFormatsCheckbox}
                  setUploadAnyFormatsCheckbox={setUploadAnyFormatsCheckbox}
                  allowFolowingFormatsCheckbox={allowFolowingFormatsCheckbox}
                  setAllowFolowingFormatsCheckbox={
                    setAllowFolowingFormatsCheckbox
                  }
                  denyForamtsCheckbox={denyForamtsCheckbox}
                  setDenyForamtsCheckbox={setDenyForamtsCheckbox}
                  fileFormats={fileFormats}
                  setFileFormats={setFileFormats}
                  potentialCustomers={potentialCustomers}
                  setPotentialCustomers={setPotentialCustomers}
                  customersFilesDownloaded={customersFilesDownloaded}
                  setCustomersFilesDownloaded={setCustomersFilesDownloaded}
                  orderConfirmation={orderConfirmation}
                  setOrderConfirmation={setOrderConfirmation}
                  sendEmailToRecipients={sendEmailToRecipients}
                  setSendEmailToRecipients={setSendEmailToRecipients}
                  displayLink={displayLink}
                  setDisplayLink={setDisplayLink}
                  displaySendAnotherEmail={displaySendAnotherEmail}
                  setDisplaySendAnotherEmail={setDisplaySendAnotherEmail}
                  thankyouPageRedirect={thankyouPageRedirect}
                  setThankyouPageRedirect={setThankyouPageRedirect}
                  redirectLink={redirectLink}
                  setRedirectLink={setRedirectLink}
                  protectFormWithPassword={protectFormWithPassword}
                  setProtectFormWithPassword={setProtectFormWithPassword}
                  passwordForm={passwordForm}
                  setPasswordForm={setPasswordForm}
                  allowAccess={allowAccess}
                  setAllowAccess={setAllowAccess}
                  showImage={showImage}
                  setShowImage={setShowImage}
                  showDescription={showDescription}
                  setShowDescription={setShowDescription}
                  showTitle={showTitle}
                  setShowTitle={setShowTitle}
                  setOldFormId={setOldFormId}
                  oldFormId={oldFormId}
                  displayToSubUsers={displayToSubUsers}
                  setDisplayToSubUsers={setDisplayToSubUsers}
                  formMaxHeight={formMaxHeight}
                  setFormMaxHeight={setFormMaxHeight}
                  deleteMailLink={deleteMailLink}
                  setDeleteMailLink={setDeleteMailLink}
                  viewMode={viewMode}
                  setViewMode={setViewMode}
                  displayTypeSubUsers={displayTypeSubUsers}
                  setDisplayTypeSubUsers={setDisplayTypeSubUsers}
                  listDomains={listDomains}
                  setListDomains={setListDomains}
                  isCheckedPreventDisplayForm={isCheckedPreventDisplayForm}
                  setIsCheckedPreventDisplayForm={
                    setIsCheckedPreventDisplayForm
                  }
                />
                <ProductTourWrapper isPageReady={true} />
              </>
            ) : editOrCreate === "create" && !embedUser ? (
              <div className="not-embed-container">
                <Icon iconClass="no-forms-img" name="no-forms" xxxl />
                <p>{getTextByKey("create-form-not-embed-text")}</p>
                <LinkToNewTab page={"purchase/premium/yearly"}>
                  <Button>
                    {getTextByKey("renew-old-subscripition-button")}
                  </Button>
                </LinkToNewTab>
              </div>
            ) : (
              <div className="not-embed-container">
                <Icon iconClass="no-forms-img" name="no-forms" xxxl="true" />
                <h1>{getTextByKey("not-your-form-title")}</h1>
                <p>{getTextByKey("not-your-form-text")}</p>
              </div>
            )}
          </div>
        ) : (
          <NotLoginContainer
            TitleKey={"create-form-not-login-title"}
            TextKey={"create-form-not-login-text"}
          />
        )
      ) : (
        <LoadingContainerElement />
      )}
    </>
  );
};

export default CreateJumboForm;
